import { _ as r } from "../internals/export.js";
r({
  target: "Number",
  stat: !0,
  nonConfigurable: !0,
  nonWritable: !0
}, {
  MIN_SAFE_INTEGER: -9007199254740991
});